import { ContainerProps } from "./types";
import classes from "./container.module.scss";

export const Container = ({ children }: ContainerProps) => {
    return <div className={classes.container}>{children}</div>;
};